import { QueryResult } from '@apollo/client'
import { GetDsDisciplinesQuery, useGetDsDisciplinesQuery } from 'schema'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useProjectContext } from 'context/ProjectContext'

type GetDsDisciplinesQueryResult = QueryResult<GetDsDisciplinesQuery>

export type Discipline = GetDsDisciplinesQuery['dsDisciplines']['records'][0]

const { Provider, useContextFn } = createStrictContext<{
  records: Discipline[]
  refetch: GetDsDisciplinesQueryResult['refetch']
  fetching: GetDsDisciplinesQueryResult['loading']
}>('DisciplinesTableContext')

export const useDisciplinesTableContext = useContextFn

export const DisciplinesTableProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const {
    data,
    refetch,
    loading: fetching,
  } = useGetDsDisciplinesQuery({
    ...DefaultQueryHookOptions,
    variables: {
      dsDisciplineListInput: {
        projectId: { equals: projectId },
      },
    },
  })

  return (
    <Provider
      value={{
        records: data?.dsDisciplines.records ?? [],
        refetch,
        fetching,
      }}
    >
      {children}
    </Provider>
  )
}
